export default "__VITE_ASSET__BvXvOlui__"